import React, { useEffect, useState } from "react"
import { AlertDialog, Button, Flex } from "@radix-ui/themes"
import { useAuth } from "../contexts/AuthContext"
import { useRestaurantAuth } from "../contexts/RestaurantAuthContext"
import { useLanguage } from "../contexts/LanguageContext"

type SessionType = "admin" | "restaurant"

interface SessionExpiredEventDetail {
    type: SessionType
}

export const SessionExpiryDialog: React.FC = () => {
    const [isOpen, setIsOpen] = useState(false)
    const [sessionType, setSessionType] = useState<SessionType | null>(null)

    const { logout: adminLogout } = useAuth()
    const { logout: restaurantLogout } = useRestaurantAuth()
    const { t } = useLanguage()

    useEffect(() => {
        const handleSessionExpired = (event: CustomEvent<SessionExpiredEventDetail>) => {
            setSessionType(event.detail.type)
            setIsOpen(true)
        }

        window.addEventListener("session-expired" as any, handleSessionExpired)

        return () => {
            window.removeEventListener("session-expired" as any, handleSessionExpired)
        }
    }, [])

    const handleLoginAgain = () => {
        setIsOpen(false)
        if (sessionType === "admin") {
            adminLogout()
        } else if (sessionType === "restaurant") {
            restaurantLogout()
        } else {
            // Fallback
            window.location.href = "/login"
        }
    }

    return (
        <AlertDialog.Root open={isOpen}>
            <AlertDialog.Content style={{ maxWidth: 450 }}>
                <AlertDialog.Title>{t("sessionExpired")}</AlertDialog.Title>
                <AlertDialog.Description size="2">
                    {t("sessionExpiredDesc")}
                </AlertDialog.Description>

                <Flex gap="3" mt="4" justify="end">
                    <Button variant="solid" color="red" onClick={handleLoginAgain}>
                        {t("logInAgain")}
                    </Button>
                </Flex>
            </AlertDialog.Content>
        </AlertDialog.Root>
    )
}
